module.exports = __webpack_public_path__ + "img/recipe-aside.8f42067f.png";